import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from 'react-loader';
import { getFormValues } from 'redux-form';
import {
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import Layout from '../components/Layout';
import PageNav from '../components/PageNav';
import EmployeeForm from '../modules/EmployeeForm';
import { fetchEmployeeDetail } from '../modules/EmployeeDetail/actions';
import { isLoaded, getError } from '../modules/EmployeeDetail/selectors';
import { deleteEmployee } from '../modules/EmployeeList/actions';
import { EMPLOYEE_FORM_NAME } from '../modules/EmployeeForm/constants';

class EditEmployeePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    const { id, lang } = this.props.match.params;
    this.props.fetchEmployeeDetail(id, lang);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  deleteEmployee = () => {
    const { id, lang } = this.props.match.params;
    this.props.deleteEmployee(id, lang, () => {
      this.toggle();
      this.props.history.push('/zamestnanci');
    });
  };

  getConfig = () => {
    const { state } = this.props.location;
    if (!state) {
      return undefined;
    } else {
      return state;
    }
  };

  render() {
    const { isLoaded, employeeInitialValues, match } = this.props;
    const { lang } = match.params;

    const initialValues = { ...employeeInitialValues, lang };

    return (
      <Layout>
        <Container>
          <Loader loaded={isLoaded}>
            <PageNav>
              <h1>Upravit zaměstnance</h1>
              <Button onClick={this.toggle} color="danger">
                Smazat tuto mutaci
              </Button>
            </PageNav>
            <EmployeeForm
              config={this.getConfig()}
              initialValues={initialValues}
            />
            <Modal
              isOpen={this.state.modal}
              toggle={this.toggle}
              className={this.props.className}
              backdrop={this.state.backdrop}
            >
              <ModalHeader toggle={this.toggle}>Smazat</ModalHeader>
              <ModalBody>
                Opravdu chcete tuto mutaci zaměstnance smazat?
              </ModalBody>
              <ModalFooter>
                <Button color="danger" onClick={this.deleteEmployee}>
                  Smazat
                </Button>{' '}
                <Button color="secondary" onClick={this.toggle}>
                  Zrušit
                </Button>
              </ModalFooter>
            </Modal>
          </Loader>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    employeeInitialValues: getFormValues(EMPLOYEE_FORM_NAME)(state),
    isLoaded: isLoaded(state),
    error: getError(state)
  };
};

export default connect(
  mapStateToProps,
  { fetchEmployeeDetail, deleteEmployee }
)(EditEmployeePage);



// WEBPACK FOOTER //
// ./src/pages/EditEmployessPage.js